import { usePaginatedList } from 'components/Commons/PaginatedList'
import { useCallback } from 'react'
import { MAX_IMAGE_SIZE, SORT_BY_RELEVANCY } from 'components/Commons/PaginatedList/PictureSearch'
import { IMAGE_TYPE } from 'utils/uploads'
import translations from 'components/Commons/PaginatedList/PictureSearch/translations'

const ERRORS = {
  INVALID_IMAGE_EXTENSION: translations.errorInvalidImageExtension,
  UPLOAD_FAILED: translations.errorUploadFailed,
  IMAGE_SIZE: translations.errorImageSize,
}

const ACCEPTED_FILE_FORMATS = [IMAGE_TYPE.JPEG, IMAGE_TYPE.JPG, IMAGE_TYPE.PNG, IMAGE_TYPE.WEBP, IMAGE_TYPE.GIF]

function useFileUpload({ onComplete, onError } = {}) {
  const { setFiltersAndSort } = usePaginatedList()

  const customFileValidator = useCallback(
    file => {
      if (!ACCEPTED_FILE_FORMATS.includes(file?.type)) {
        onError && onError(ERRORS.INVALID_IMAGE_EXTENSION)
      } else if (file?.size > MAX_IMAGE_SIZE) {
        onError && onError(ERRORS.IMAGE_SIZE)
      }
    },
    [onError],
  )

  const onUploadComplete = useCallback(
    ({ data }) => {
      setFiltersAndSort({
        filters: {
          pictureVectorSearchImageUrl: data.url,
        },
        sort: SORT_BY_RELEVANCY,
      })
      onComplete && onComplete()
    },
    [setFiltersAndSort, onComplete],
  )

  const onUploadFailed = useCallback(() => {
    onError && onError(ERRORS.UPLOAD_FAILED)
  }, [onError])

  const onUploadRejected = useCallback(
    files => {
      customFileValidator(files?.[0]?.file)
    },
    [customFileValidator],
  )

  return {
    onUploadComplete,
    onUploadFailed,
    customFileValidator,
    onUploadRejected,
    acceptedFileTypes: ACCEPTED_FILE_FORMATS,
  }
}

export default useFileUpload
